import { WebsitesBlockedComponent } from '..';
import { WebsitesBlockedView } from '../view/WebsitesBlockedView';
import { templateWebsitesBlocked } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetWebsitesBlockedResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class WebsitesBlockedController extends BaseWidgetController<GetWebsitesBlockedResponse> {
  public component: WebsitesBlockedComponent;
  public view: WebsitesBlockedView;
  public viewConstructor: typeof WebsitesBlockedView;

  constructor(component: WebsitesBlockedComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: WebsitesBlockedView,
      viewTemplate: templateWebsitesBlocked,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getWebsitesBlocked,
    });
  }
}
